import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { MyMailbox } from "./pages";

export const MailboxesRouter = [
  <Route
    path="/my-mailbox"
    element={
      <ProtectedRoute roles={["Any"]}>
        <MyMailbox />
      </ProtectedRoute>
    }
  />,
];
